function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPeopleMemberFavoriteOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.002 28.016c.02-1.552.079-6.274 1.407-7.602.87-.87 2.439-1.955 4.415-3.055a2.964 2.964 0 001.497-2.143 2.985 2.985 0 00-.78-2.519C9.555 11.646 8.997 10.91 8.997 8c0-1.845 1.048-4 4.002-4 2.956 0 4.005 2.155 4.005 4 0 2.91-.559 3.646-1.545 4.697a2.988 2.988 0 00.718 4.662c1.976 1.1 3.545 2.185 4.415 3.055 1.328 1.328 1.387 6.05 1.418 7.586l-18.008.016zM22.007 19c-1.323-1.321-3.52-2.644-4.857-3.388a.99.99 0 01-.23-1.548c1.39-1.481 2.085-2.731 2.085-6.064 0-3-2.002-6-6.006-6-4.002 0-6.003 3-6.003 6 0 3.333.694 4.583 2.085 6.064a.989.989 0 01-.23 1.548c-1.339.744-3.535 2.067-4.857 3.388-1.678 1.676-1.95 5.456-1.994 8.991A1.986 1.986 0 003.99 30h18.02A1.986 1.986 0 0024 27.991c-.044-3.535-.316-7.315-1.993-8.991z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.034 12.059l-2.047-1.59.268-2.66a.79.79 0 00-.393-.767.79.79 0 00-.86.044l-2.17 1.562-2.4-.978a.796.796 0 00-1.068.944l.7 2.603-1.766 2.1a.796.796 0 00.605 1.307l2.58.005 1.293 2.23a.796.796 0 001.434-.13l.936-2.578 2.604-.695a.796.796 0 00.284-1.397z",
    fill: props.color
  }));
}

export default SvgIconPeopleMemberFavoriteOutline;